import { Component, inject, signal } from '@angular/core';
import { AuthStateService } from '../../../core/authentication/auth-state.service';
import { AuthService } from '../../../core/authentication/auth.service';

interface NavItem {
  label: string;
  icon: string;
  badge?: number;
  route: string;
  section?: string;
  permission?: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {

  isOpen = signal(true);
  authState = inject(AuthStateService);
  private authService = inject(AuthService);
  isLoggingOut = signal(false);

  adminItems: NavItem[] = [
    { label: 'Users', icon: 'users', badge: NaN, route: '/users', section: 'ADMINISTRATION', permission: 'users.view' },
    { label: 'Roles', icon: 'shield', badge: NaN, route: '/roles', permission: 'roles.view' },
    { label: 'Geographic nodes', icon: 'pin', badge: NaN, route: '/geographic-nodes', permission: 'nodes.view' },
    { label: 'Channels', icon: 'check', badge: NaN, route: '/channels', permission: 'channels.view' },
    { label: 'SKU management', icon: 'sku_rules', badge: NaN, route: '/sku-management', permission: 'skus.view' },
  ];

  fieldOperationsItems: NavItem[] = [
    { label: 'POS Management', icon: 'settings', route: '/pos', section: 'FIELD OPERATIONS', permission: 'pos.view' },
    { label: 'Surveys', icon: 'surveys', route: '/surveys', permission: 'surveys.view' },
  ];

  accountItems: NavItem[] = [
    { label: 'Settings', icon: 'settings', route: '/settings', section: 'ACCOUNT' },
  ];

  toggleSidebar() {
    this.isOpen.update(v => !v);
  }

  // Redirect to /login is handled by AuthStateService.clearSession()
  onLogout() {
    if (this.isLoggingOut()) return;
    this.isLoggingOut.set(true);
    this.authService.logout().subscribe({
      error: () => this.isLoggingOut.set(false),
    });
  }

  hasNavAccess(item: NavItem): boolean {
    return !item.permission || this.authState.hasPermission(item.permission);
  }

}
